/* eslint-disable */

export const sendEmailQuery = async (data) => {
    return fetch(`/customers/send-bulk-emails/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const sendEmailToAllUsersQuery = async (data) => {
    return fetch(`/customers/send-emails-to-all-users/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};
